import { useState } from "react";
import { ButtonGroup, Button, Flex } from "@chakra-ui/react";
import ScrollContainer from "react-indiana-drag-scroll";

export default function ShowSize({ series, onSizeChange }) {

    const [selected, setActive] = useState(0);

    function handleClicked(index, model) {
        setActive(index);
        onSizeChange(model);
    }

    return (
        <ScrollContainer>
            <ButtonGroup spacing="20px">
                {
                    series?.size.map((option, index) => (
                        <Button
                            w="70px"
                            h="38.5px"
                            key={option.id}
                            value={option.model}
                            _hover={{
                                backgroundColor: index === selected ? '#FED141' : '#FFFFFF'
                            }}
                            borderColor={index === selected ? '#E8D98F' : '#B2B2B2'}
                            backgroundColor={index === selected ? '#FED141' : '#FFFFFF'}
                            variant={index === selected ? 'solid' : 'outline'}
                            onClick={() => { handleClicked(index, option.model); }}
                            fontSize="12px"
                            fontWeight="600"

                        >

                            {option.size}"
                        </Button>
                    ))}
            </ButtonGroup>
        </ScrollContainer>
    );
}